import EventPageContent from '../../lib/components/event/EventPageContent';
import DefaultPageLayout from '../../lib/components/layout/DefaultPageLayout';
import BreadcrumbNav from '../../lib/components/layout/Nav/BreadcrumbNav';
import PageContainer from '../../lib/components/layout/PageContainer';
import NotFoundPage from '../NotFound/NotFound';

import React from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

type Params = {
  readonly id: string;
};

export default function EventPage(): JSX.Element {
  const {id} = useParams<Params>();
  const {t} = useTranslation();

  if (id == null) {
    return <NotFoundPage />;
  }

  return (
    <DefaultPageLayout>
      <PageContainer>
        <BreadcrumbNav
          breadcrumbs={[
            {
              name: t('pages.home.title'),
              url: '/',
            },
            {
              name: t('pages.events.title'),
              url: '/event',
            },
          ]}
        />
        <EventPageContent id={id} />
      </PageContainer>
    </DefaultPageLayout>
  );
}
